import Dispatcher from '../dispatcher';
import { FSFMotoLightBoxActions } from '../constants/fsf_moto_light_box/fsf_moto_light_box_actions';

function showAction() {
    Dispatcher.handleFSFMotoLightboxAction({
        type: FSFMotoLightBoxActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleFSFMotoLightboxAction({
        type: FSFMotoLightBoxActions.HIDE
    });
}

export {
    showAction,
    hideAction
};